export function WidgetIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 4a3 3 0 00-3 3v10a3 3 0 003 3h3a1 1 0 100-2H5a1 1 0 01-1-1V7a1 1 0 011-1h3a1 1 0 000-2H5zM16 4a1 1 0 100 2h3a1 1 0 011 1v10a1 1 0 01-1 1h-3a1 1 0 100 2h3a3 3 0 003-3V7a3 3 0 00-3-3h-3z"
      ></path>
      <path
        fill="currentColor"
        d="M10 8.648c0-.51.516-.82.91-.546l4.816 3.352c.365.254.365.838 0 1.092l-4.816 3.352c-.394.274-.91-.036-.91-.546V8.648z"
      ></path>
    </svg>
  );
}
